"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuidV4 = uuidV4;
const uuid_1 = require("uuid");
function uuidV4() {
    return (0, uuid_1.v4)();
}
